const message_PT = {
    "data": [
        {
            "code": 500000,
            "message": "Erro interno do sistema"
        },
        {
            "code": 500001,
            "message": "Patrocinador não encontrado"
        },
        {
            "code": 500002,
            "message": "Erro de pagamento"
        },
        {
            "code": 500003,
            "message": "Erro na conversão de moedas"
        },
        {
            "code": 500004,
            "message": "Método de pagamento não encontrado"
        },
        {
            "code": 500005,
            "message": "Gateway de pagamento não encontrado"
        },
        {
            "code": 500006,
            "message": "Plano não encontrado"
        },
        {
            "code": 500007,
            "message": "Valor é nulo ou zero"
        },
        {
            "code": 500008,
            "message": "Valor é nulo ou saldo insuficiente na carteira"
        },
        {
            "code": 500009,
            "message": "Cliente especial não pode ser patrocinador"
        },
        {
            "code": 500010,
            "message": "Id do plano deve ser Business Partner"
        },
        {
            "code": 500011,
            "message": "Patrocinador do usuário não encontrado"
        },
        {
            "code": 500012,
            "message": "Usuário não encontrado"
        },
        {
            "code": 500013,
            "message": "Falha na tentativa de autenticar o usuário"
        },
        {
            "code": 500014,
            "message": "Erro ao decodificar token JWT"
        },
        {
            "code": 500015,
            "message": "Este token JWT não pertence ao usuário da requisição"
        },
        {
            "code": 500016,
            "message": "Nome de usuário não está disponível"
        },
        {
            "code": 500017,
            "message": "Já existe uma conta associada a este e-mail"
        },
        {
            "code": 500018,
            "message": "Campo Currency está vazio ou nulo"
        },
        {
            "code": 500019,
            "message": "Erro no upload do arquivo"
        },
        {
            "code": 500020,
            "message": "Pagamento por transferência não pôde ser confirmado"
        },
        {
            "code": 500021,
            "message": "Cliente especial não pode transferir ExtraCoin"
        },
        {
            "code": 500022,
            "message": "Saldo insuficiente na carteira ExtraCoin"
        },
        {
            "code": 500023,
            "message": "Saldo insuficiente na carteira"
        },
        {
            "code": 500024,
            "message": "Já existe uma conta associada a este número de documento"
        },
        {
            "code": 500025,
            "message": "Este e-mail não corresponde a este usuário"
        },
        {
            "code": 500026,
            "message": "Plano do usuário não encontrado"
        },
        {
            "code": 500027,
            "message": "Voucher inválido"
        },
        {
            "code": 500028,
            "message": "Pagamento com voucher é válido apenas para cadastro de Area Manager"
        },
        {
            "code": 500029,
            "message": "Id da transação não encontrado"
        },
        {
            "code": 500030,
            "message": "Esta transação não pertence a este usuário"
        },
        {
            "code": 500031,
            "message": "Esta transação não está pendente de confirmação de transferência"
        },
        {
            "code": 500032,
            "message": "Categoria não encontrada com o id correspondente"
        },
        {
            "code": 500033,
            "message": "Atributo não encontrado com o id correspondente"
        },
        {
            "code": 500034,
            "message": "O id do atributo não corresponde ao usuário da requisição"
        },
        {
            "code": 500035,
            "message": "Cliente especial não pode criar produtos"
        },
        {
            "code": 500036,
            "message": "Subcategoria não encontrada"
        },
        {
            "code": 500037,
            "message": "Produto não encontrado"
        },
        {
            "code": 500038,
            "message": "O id do produto não pertence ao usuário da requisição"
        },
        {
            "code": 500039,
            "message": "O produto já está associado a este atributo"
        },
        {
            "code": 500040,
            "message": "Valor mínimo para criar um cupom é 50"
        },
        {
            "code": 500042,
            "message": "Cupom inválido"
        },
        {
            "code": 500043,
            "message": "O cupom não pertence ao usuário patrocinador"
        },
        {
            "code": 500044,
            "message": "Cliente especial não pode criar cupons"
        },
        {
            "code": 500045,
            "message": "O produto não está associado a este atributo"
        },
        {
            "code": 500046,
            "message": "O produto já possui variações registradas"
        },
        {
            "code": 500047,
            "message": "Você não pode criar uma variação com os mesmos atributos"
        },
        {
            "code": 500048,
            "message": "Todos os atributos devem ter pelo menos um valor atribuído"
        },
        {
            "code": 500049,
            "message": "Marca não está associada à subcategoria"
        },
        {
            "code": 500050,
            "message": "Campo subcategory não encontrado"
        },
        {
            "code": 500051,
            "message": "Marca não encontrada"
        },
        {
            "code": 500052,
            "message": "Tipo não está associado à subcategoria"
        },
        {
            "code": 500053,
            "message": "Tipo não encontrado"
        },
        {
            "code": 500054,
            "message": "GenderProduct não está associado à subcategoria"
        },
        {
            "code": 500055,
            "message": "GenderProduct não encontrado"
        },
        {
            "code": 500056,
            "message": "Variação do produto não encontrada"
        },
        {
            "code": 500057,
            "message": "Produto pode ter apenas 2 atributos"
        },
        {
            "code": 500058,
            "message": "Produto não possui nenhum atributo registrado"
        },
        {
            "code": 500059,
            "message": "Este produto possui variações. Você não pode definir o valor total"
        },
        {
            "code": 500060,
            "message": "Esta variação não corresponde a este produto"
        },
        {
            "code": 500061,
            "message": "Campo Language está vazio ou nulo"
        },
        {
            "code": 500062,
            "message": "O pedido deve ter pelo menos um item"
        },
        {
            "code": 500063,
            "message": "Status permitido: PUBLISHED ou UNPUBLISHED"
        },
        {
            "code": 500064,
            "message": "Comprador e vendedor devem ser diferentes"
        },
        {
            "code": 500065,
            "message": "Pedido não encontrado"
        },
        {
            "code": 500066,
            "message": "Este pedido não pertence a este usuário"
        },
        {
            "code": 500067,
            "message": "O produto no item não pertence ao vendedor do pedido"
        },
        {
            "code": 500068,
            "message": "Item não encontrado no pedido"
        },
        {
            "code": 500069,
            "message": "Este produto possui variações, especifique um idvariation"
        },
        {
            "code": 500070,
            "message": "Percentual de extracoin deve estar entre 50% e 97% para Business Partners"
        },
        {
            "code": 500071,
            "message": "Percentual de extracoin deve estar entre 10% e 97% para Area Managers"
        },
        {
            "code": 500072,
            "message": "Percentual de extracoin está acima do solicitado pelo vendedor"
        },
        {
            "code": 500073,
            "message": "A soma de Extracoin + Wallet + Cash deve ser igual ao total do pedido"
        },
        {
            "code": 500074,
            "message": "Fora de estoque -> Produto"
        },
        {
            "code": 500075,
            "message": "Não é possível modificar/excluir um item de um pedido que não está aberto"
        },
        {
            "code": 500076,
            "message": "O valor máximo possível de extracoin foi excedido. Revise seu pedido!"
        },
        {
            "code": 500077,
            "message": "Este usuário não é o vendedor deste pedido"
        },
        {
            "code": 500078,
            "message": "Este pedido não pode ser enviado"
        },
        {
            "code": 500079,
            "message": "Este usuário não é o comprador deste pedido"
        },
        {
            "code": 500080,
            "message": "Este pedido não pode ser recebido"
        },
        {
            "code": 500081,
            "message": "Carreira não encontrada"
        },
        {
            "code": 500082,
            "message": "A carteira de origem tem saldo insuficiente para pagar a taxa"
        },
        {
            "code": 500083,
            "message": "A carteira de destino tem saldo insuficiente para pagar a taxa"
        },
        {
            "code": 500084,
            "message": "A carteira Extracoin de origem tem saldo insuficiente para transferir"
        },
        {
            "code": 500085,
            "message": "A carteira Extracoin de destino tem saldo insuficiente para transferir"
        },
        {
            "code": 500086,
            "message": "ID de transferência não encontrado"
        },
        {
            "code": 500087,
            "message": "Este usuário não tem relação com esta transferência"
        },
        {
            "code": 500088,
            "message": "Usuário de origem e destino são iguais"
        },
        {
            "code": 500089,
            "message": "Código de confirmação de transferência incorreto"
        },
        {
            "code": 500090,
            "message": "O usuário de origem ainda não confirmou a transação"
        },
        {
            "code": 500091,
            "message": "Você só pode avaliar pedidos que marcou como recebidos"
        },
        {
            "code": 500092,
            "message": "Você já avaliou este pedido"
        },
        {
            "code": 500093,
            "message": "As avaliações devem estar entre 1 e 5"
        },
        {
            "code": 500094,
            "message": "Senha atual incorreta"
        },
        {
            "code": 500095,
            "message": "A nova senha deve ser diferente da senha atual"
        },
        {
            "code": 500096,
            "message": "Token de confirmação de telefone não encontrado"
        },
        {
            "code": 500097,
            "message": "Este número de telefone já está confirmado"
        },
        {
            "code": 500098,
            "message": "Código inválido - confirmação de número de telefone"
        },
        {
            "code": 500099,
            "message": "Apenas Clientes especiais podem fazer upgrade para Area Manager"
        },
        {
            "code": 500100,
            "message": "Já existe um pagamento associado a este transactionid"
        },
        {
            "code": 500101,
            "message": "A transação de pagamento não pôde ser confirmada"
        },
        {
            "code": 500102,
            "message": "Apenas Clientes especiais podem fazer upgrade para Business Partner"
        },
        {
            "code": 500103,
            "message": "Usuário inativo. Você não pode solicitar saques."
        },
        {
            "code": 500104,
            "message": "O usuário remetente não tem relação com este pedido"
        },
        {
            "code": 500105,
            "message": "O usuário destinatário não tem relação com este pedido"
        },
        {
            "code": 500106,
            "message": "Mensagem de chat não encontrada"
        },
        {
            "code": 500107,
            "message": "Usuário não é o destinatário desta mensagem de chat"
        },
        {
            "code": 500108,
            "message": "Este usuário não pode ver as mensagens deste pedido"
        },
        {
            "code": 500109,
            "message": "Este perfil não pode indicar um Sale Promoter"
        },
        {
            "code": 500110,
            "message": "Id do plano deve ser Sale Promoter"
        },
        {
            "code": 500111,
            "message": "Sale Promoter não pode criar produtos"
        },
        {
            "code": 500112,
            "message": "Admin não pode criar produtos"
        },
        {
            "code": 500113,
            "message": "Usuário não tem permissão de admin (superuser)"
        },
        {
            "code": 500114,
            "message": "Campos latitude/longitude são obrigatórios"
        },
        {
            "code": 500115,
            "message": "Campo origin of register é obrigatório"
        },
        {
            "code": 500116,
            "message": "Se o produto for para download, informe os campos downloadtype, urldownload e urldownloadsample"
        },
        {
            "code": 500117,
            "message": "Se pelo menos um item for produto para download, todos os itens devem ser para download"
        },
        {
            "code": 500118,
            "message": "Este pedido não possui itens para download"
        },
        {
            "code": 500119,
            "message": "Este dispositivo já está registrado"
        },
        {
            "code": 500120,
            "message": "Este dispositivo não está registrado"
        },
        {
            "code": 500121,
            "message": "Este dispositivo não pertence a este usuário"
        },
        {
            "code": 500122,
            "message": "Produto para download não pode criar variações"
        },
        {
            "code": 500123,
            "message": "Produto para download não pode receber atributos"
        },
        {
            "code": 500124,
            "message": "Saque mínimo permitido violado"
        },
        {
            "code": 500125,
            "message": "Apenas Area Managers podem criar produtos com informações técnicas"
        },
        {
            "code": 500126,
            "message": "Id de informação técnica não encontrado"
        },
        {
            "code": 500127,
            "message": "Campos weight, height, width ou length não encontrados"
        },
        {
            "code": 500128,
            "message": "Este produto já foi favoritado por este usuário"
        },
        {
            "code": 500129,
            "message": "Este produto não foi favoritado por este usuário"
        },
        {
            "code": 500130,
            "message": "Saque não encontrado"
        },
        {
            "code": 500131,
            "message": "Este saque já foi processado"
        },
        {
            "code": 500132,
            "message": "Este usuário já está bloqueado"
        },
        {
            "code": 500133,
            "message": "Este usuário já está desbloqueado"
        },
        {
            "code": 500134,
            "message": "Busca não encontrada"
        },
        {
            "code": 500135,
            "message": "Esta busca já foi confirmada"
        },
        {
            "code": 500136,
            "message": "Já existe uma Marca com esta descrição"
        },
        {
            "code": 500137,
            "message": "Este tipo já está associado a esta subcategoria"
        },
        {
            "code": 500138,
            "message": "Esta marca já está associada a esta subcategoria"
        },
        {
            "code": 500139,
            "message": "Configuração do marketplace não encontrada"
        },
        {
            "code": 500140,
            "message": "Este produto não pode ser enviado. Entre em contato com o vendedor."
        },
        {
            "code": 500141,
            "message": "Ainda não enviamos deste país."
        },
        {
            "code": 500142,
            "message": "Não encontramos transportadora para seu pedido."
        },
        {
            "code": 500143,
            "message": "Este vendedor ainda não pode enviar"
        },
        {
            "code": 500144,
            "message": "Este produto não pode ser enviado no momento"
        },
        {
            "code": 500146,
            "message": "Produtos para download não podem ser enviados"
        },
        {
            "code": 500147,
            "message": "Serviços não podem ser enviados"
        },
        {
            "code": 500148,
            "message": "Este pedido ainda não possui encomenda atribuída. Aguarde alguns minutos e tente novamente!"
        },
        {
            "code": 500149,
            "message": "Já existe coleta agendada para esta encomenda"
        },
        {
            "code": 500150,
            "message": "Apenas o vendedor pode agendar coleta"
        },
        {
            "code": 500151,
            "message": "Conversão não encontrada"
        },
        {
            "code": 500152,
            "message": "Conversão expirada"
        },
        {
            "code": 500153,
            "message": "Esta conversão não pertence ao usuário da requisição"
        },
        {
            "code": 500154,
            "message": "Esta conversão já foi utilizada"
        },
        {
            "code": 500155,
            "message": "Este usuário já cadastrou o endereço. Para modificar, entre em contato com o suporte."
        },
        {
            "code": 500156,
            "message": "Este pedido contém um serviço. Todos os itens devem ser serviços."
        },
        {
            "code": 500157,
            "message": "Este pedido não está associado a uma encomenda."
        },
        {
            "code": 500158,
            "message": "Partners não podem criar mais de 50 produtos publicados!"
        },
        {
            "code": 500159,
            "message": "Partners não podem criar mais de 50 produtos não publicados!"
        },
        {
            "code": 500160,
            "message": "Você possui assinatura trial! Não pode solicitar saques!"
        },
        {
            "code": 500161,
            "message": "Apenas Managers e Partners precisam renovar a assinatura!"
        },
        {
            "code": 500162,
            "message": "Você só pode renovar a assinatura a partir de 10 dias antes do vencimento!"
        },
        {
            "code": 500163,
            "message": "Renovação não pode ser paga com este método de pagamento!"
        },
        {
            "code": 500164,
            "message": "Este método só pode pagar renovação!"
        },
        {
            "code": 500165,
            "message": "Este voucher não pode ser usado para pagar este plano!"
        },
        {
            "code": 500166,
            "message": "Código de segurança inválido ou expirado"
        },
        {
            "code": 500167,
            "message": "Id do plano deve ser Seller"
        },
        {
            "code": 500168,
            "message": "Percentual de extracoin deve estar entre 30% e 97% para Sellers"
        },
        {
            "code": 500169,
            "message": "Um produto não pode ser serviço e para download ao mesmo tempo"
        },
        {
            "code": 500170,
            "message": "Você está tentando adicionar um serviço a um pedido com itens que não são serviços"
        },
        {
            "code": 500171,
            "message": "Pergunta do produto não encontrada"
        },
        {
            "code": 500172,
            "message": "Este usuário não pode responder esta pergunta"
        },
        {
            "code": 500173,
            "message": "Esta pergunta já foi respondida"
        },
        {
            "code": 500174,
            "message": "Você não pode perguntar sobre seu próprio produto"
        },
        {
            "code": 500175,
            "message": "Notificação não encontrada"
        },
        {
            "code": 500176,
            "message": "Esta notificação não pertence ao usuário da requisição"
        },
        {
            "code": 500177,
            "message": "Suas notificações não puderam ser enviadas porque seu saldo de extracoin é insuficiente, mas seu produto foi registrado corretamente"
        },
        {
            "code": 500178,
            "message": "Se seu pedido tiver pelo menos um item com frete grátis, todos os itens devem ter frete grátis"
        },
        {
            "code": 500179,
            "message": "Você não pode criar produtos"
        },
        {
            "code": 500180,
            "message": "Você não pode fazer upgrade para SilverPro"
        },
        {
            "code": 500181,
            "message": "Você não pode fazer upgrade para GeoGold"
        },
        {
            "code": 500182,
            "message": "Você não pode fazer upgrade para StartSeller"
        },
        {
            "code": 500183,
            "message": "Share Content não encontrado"
        },
        {
            "code": 500184,
            "message": "Este produto já foi compartilhado por este usuário"
        },
        {
            "code": 500185,
            "message": "Carteira Extrabonus não encontrada"
        },
        {
            "code": 500186,
            "message": "Este pedido não pode ser retirado no endereço do vendedor"
        },
        {
            "code": 500187,
            "message": "publicKey não encontrada"
        },
        {
            "code": 500188,
            "message": "transactionidCrypto não encontrado"
        },
        {
            "code": 500189,
            "message": "Erro de pagamento. Não foi possível confirmar a transação da sua carteira crypto."
        },
        {
            "code": 500190,
            "message": "Se o produto for importado, informe o campo OriginProductImported"
        },
        {
            "code": 500191,
            "message": "Se o produto for importado da Banggood, informe o campo ProductIdBanggood"
        },
        {
            "code": 500192,
            "message": "Este produto não está atribuído a este atributo"
        },
        {
            "code": 500193,
            "message": "Este atributo está atribuído em pelo menos uma variação! Exclua as variações primeiro!"
        },
        {
            "code": 500194,
            "message": "Edite seu produto e defina o percentual de cashback antes de publicar"
        },
        {
            "code": 500195,
            "message": "Percentual de cashback deve estar entre 1% e 5% para Customers"
        },
        {
            "code": 500196,
            "message": "Loja não encontrada"
        },
        {
            "code": 500197,
            "message": "Esta loja não pertence a este usuário"
        },
        {
            "code": 500198,
            "message": "Slug não disponível"
        },
        {
            "code": 500199,
            "message": "Este pedido já está PAGO"
        },
        {
            "code": 500200,
            "message": "Este pagamento não possui transferência bancária associada"
        },
        {
            "code": 500201,
            "message": "PaymentPlan não encontrado"
        },
        {
            "code": 500202,
            "message": "Este PaymentPlan já está pago"
        },
        {
            "code": 500203,
            "message": "Produto não disponível para venda"
        },
        {
            "code": 500204,
            "message": "Apenas perfil de loja pode usar este tipo de pagamento"
        },
        {
            "code": 500205,
            "message": "Pagamento não encontrado"
        },
        {
            "code": 500206,
            "message": "Falha na autenticação"
        },
        {
            "code": 500207,
            "message": "A soma dos valores das duas carteiras (principal + extracredit) deve ser igual ao valor a pagar"
        },
        {
            "code": 500208,
            "message": "Seu perfil não permite esta operação"
        },
        {
            "code": 500209,
            "message": "Seção do marketplace não encontrada"
        },
        {
            "code": 500210,
            "message": "Loja ainda não configurada! Configure-a primeiro."
        },
        {
            "code": 500211,
            "message": "Este perfil não pode indicar este cadastro"
        },
        {
            "code": 500212,
            "message": "Fringe Benefit não encontrado"
        },
        {
            "code": 500213,
            "message": "Fringe Benefit Order não encontrado"
        },
        {
            "code": 500214,
            "message": "Fringe Benefit Order já está pago"
        },
        {
            "code": 500215,
            "message": "Este Fringe Benefit Order não pertence a este usuário"
        },
        {
            "code": 500216,
            "message": "Quantidade insuficiente deste benefício"
        },
        {
            "code": 500217,
            "message": "A soma de Extracoin + Wallet + Paypal deve ser o total do pedido"
        },
        {
            "code": 500218,
            "message": "Não há pagamento atribuído a este pedido"
        },
        {
            "code": 500219,
            "message": "Voucher Fringe Benefit não encontrado"
        },
        {
            "code": 500220,
            "message": "Voucher Fringe Benefit já foi utilizado"
        },
        {
            "code": 500221,
            "message": "Este voucher não pode ser usado neste vendedor"
        },
        {
            "code": 500222,
            "message": "Instância Whatsapp não encontrada"
        },
        {
            "code": 500223,
            "message": "Endereço não encontrado"
        },
        {
            "code": 500224,
            "message": "Este endereço não pertence a este usuário"
        },
        {
            "code": 500225,
            "message": "Este pedido não é para retirada no endereço da loja"
        },
        {
            "code": 500226,
            "message": "Este pedido já é para retirada no endereço da loja"
        },
        {
            "code": 500227,
            "message": "Documento não encontrado"
        },
        {
            "code": 500228,
            "message": "Não foi possível confirmar seu e-mail"
        },
        {
            "code": 500230,
            "message": "Nenhuma solicitação de alteração de senha encontrada"
        },
        {
            "code": 500231,
            "message": "Esta solicitação de alteração de senha já foi utilizada"
        },
        {
            "code": 500232,
            "message": "Personalização de tema permitida apenas para Managers"
        },
        {
            "code": 500233,
            "message": "Tema não encontrado"
        },
        {
            "code": 500234,
            "message": "Este usuário não pode personalizar o tema"
        },
        {
            "code": 500235,
            "message": "Formato de telefone inválido. Use o formato internacional com código do país (ex.: +393471234567)."
        },
        {
            "code": 500236,
            "message": "Conta bancária não encontrada ou não pertence a este usuário"
        },
        {
            "code": 500237,
            "message": "Nome do banco, IBAN e titular da conta são obrigatórios"
        },
        {
            "code": 500238,
            "message": "Número Whatsapp não encontrado, não pertence a este usuário ou já confirmado"
        },
        {
            "code": 500239,
            "message": "Este usuário já possui número WhatsApp associado! Remova-o para adicionar outro."
        },
        {
            "code": 500240,
            "message": "Apenas managers podem criar uma subnet"
        },
        {
            "code": 500241,
            "message": "Este usuário já possui uma subnet"
        },
        {
            "code": 500242,
            "message": "Código ATECO não encontrado"
        },
        {
            "code": 500243,
            "message": "Usuário não autorizado a remover este código ATECO"
        },
        {
            "code": 500244,
            "message": "Usuário não pertence a nenhuma subnet"
        },
        {
            "code": 500245,
            "message": "Usuário já pertence a uma subnet"
        },
        {
            "code": 500246,
            "message": "Complete seu cadastro com seu endereço ou autorize o compartilhamento da geolocalização."
        },
        {
            "code": 500247,
            "message": "Este usuário já possui formulário de perfil preenchido"
        },
        {
            "code": 500248,
            "message": "Customers não podem criar mais de 5 produtos publicados"
        },
        {
            "code": 500249,
            "message": "Customers não podem criar mais de 5 produtos não publicados"
        },
        {
            "code": 500250,
            "message": "Subnet não encontrada"
        },
        {
            "code": 500251,
            "message": "Este usuário não pertence a esta subnet"
        },
        {
            "code": 500252,
            "message": "Loja não aprovada para vendas em loja física. Envie primeiro a comprovação de loja física."
        },
        {
            "code": 500253,
            "message": "Nenhuma comprovação de loja física encontrada para este usuário"
        },
        {
            "code": 500254,
            "message": "Campo reason é obrigatório para rejeição"
        },
        {
            "code": 500255,
            "message": "Esta loja já é StartSeller"
        },
        {
            "code": 500256,
            "message": "Campo physicalStoreName é obrigatório"
        },
        {
            "code": 500257,
            "message": "Campo proofPhotoUrl é obrigatório"
        },
        {
            "code": 500258,
            "message": "Campo physicalAddress é obrigatório"
        },
        {
            "code": 500259,
            "message": "Campo physicalCity é obrigatório"
        },
        {
            "code": 500260,
            "message": "A loja deve aceitar os termos da convenção para prosseguir"
        },
        {
            "code": 500261,
            "message": "Nenhuma convenção assinada encontrada para esta loja"
        },
        {
            "code": 500262,
            "message": "Campo legalRepresentativeName é obrigatório"
        },
        {
            "code": 500263,
            "message": "Campo taxId (Partita IVA / C.F.) é obrigatório"
        },
        {
            "code": 500264,
            "message": "Campo commercialName (Insegna) é obrigatório"
        },
        {
            "code": 500265,
            "message": "Campo address é obrigatório"
        },
        {
            "code": 500266,
            "message": "Campo city é obrigatório"
        },
        {
            "code": 500267,
            "message": "Campo merchantCategory é obrigatório"
        },
        {
            "code": 500268,
            "message": "A loja deve assinar a convenção Extraconomy antes de enviar a comprovação de loja física"
        },
        {
            "code": 500300,
            "message": "Falha ao autenticar na API Aruba (signin)"
        },
        {
            "code": 500301,
            "message": "Falha ao renovar o token da API Aruba (refresh)"
        },
        {
            "code": 500310,
            "message": "Não foi possível determinar a província fiscal"
        },
        {
            "code": 500311,
            "message": "Documento do usuário está vazio"
        },
        {
            "code": 500312,
            "message": "Documento do usuário não corresponde a Codice Fiscale nem a Partita IVA"
        },
        {
            "code": 500313,
            "message": "Este tipo de usuário não possui dados fiscais ou de endereço"
        },
        {
            "code": 500314,
            "message": "Dados cadastrais incompletos para emitir a fattura"
        },
        {
            "code": 500315,
            "message": "Configuração do cedente (Extraconomy) está incompleta"
        },
        {
            "code": 500320,
            "message": "Este tipo de usuário não possui dados fiscais"
        },
        {
            "code": 500321,
            "message": "É necessário informar se é Pessoa Física ou jurídica"
        },
        {
            "code": 500322,
            "message": "Tipo de pessoa inválido"
        },
        {
            "code": 500323,
            "message": "Este tipo de usuário não pode ser alterado para o tipo selecionado"
        },
        {
            "code": 500324,
            "message": "Nome fiscal é obrigatório para Pessoa Jurídica"
        },
        {
            "code": 500325,
            "message": "Nome e sobrenome são obrigatórios para Pessoa Física"
        },
        {
            "code": 500326,
            "message": "Documento (CF/P.IVA) é obrigatório"
        },
        {
            "code": 500327,
            "message": "Endereço é obrigatório"
        },
        {
            "code": 500328,
            "message": "Número é obrigatório"
        },
        {
            "code": 500329,
            "message": "CAP/CEP é obrigatório"
        },
        {
            "code": 500330,
            "message": "Cidade é obrigatória"
        },
        {
            "code": 500331,
            "message": "País é obrigatório"
        },
        {
            "code": 500332,
            "message": "CPF ou CPNJ Inválidos"
        },
        {
            "code": 500400,
            "message": "Faturação automática bloqueada"
        },
        {
            "code": 500410,
            "message": "Valor de saque inválido (nulo ou ≤ 0)"
        },
        {
            "code": 500411,
            "message": "Carteira de tokens não encontrada para o usuário"
        },
        {
            "code": 500412,
            "message": "Saldo insuficiente para o saque solicitado"
        },
        {
            "code": 500413,
            "message": "Solicitação de saque não encontrada (ao processar)"
        },
        {
            "code": 500414,
            "message": "Solicitação já havia sido processada anteriormente"
        },
        {
            "code": 500415,
            "message": "Informe o endereço EXC para o saque"
        },
        {
            "code": 500416,
            "message": "Informe o código de verificação enviado por e-mail"
        }
    ]
}

export default message_PT;
